var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeamlessInte(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 103.092,
    height: 102.079,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(-506 -1964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(511 1970)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M17.111,68.507a2.378,2.378,0,1,1-2.378,2.378,2.378,2.378,0,0,1,2.378-2.378",
    transform: "translate(-1.151 -5.354)",
    fill: "#2e77ea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M94.867,68.507a2.378,2.378,0,1,1-2.378,2.378,2.378,2.378,0,0,1,2.378-2.378",
    transform: "translate(-7.228 -5.354)",
    fill: "#2e77ea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M17.111,37.066a2.378,2.378,0,1,1-2.378,2.378,2.378,2.378,0,0,1,2.378-2.378",
    transform: "translate(-1.151 -2.897)",
    fill: "#2e77ea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M94.867,37.066a2.378,2.378,0,1,1-2.378,2.378,2.378,2.378,0,0,1,2.378-2.378",
    transform: "translate(-7.228 -2.897)",
    fill: "#2e77ea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M19.691,52.787a2.378,2.378,0,1,1-2.378,2.378,2.378,2.378,0,0,1,2.378-2.378",
    transform: "translate(-1.353 -4.125)",
    fill: "#2e77ea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M92.287,52.272a2.378,2.378,0,1,1-2.378,2.378,2.378,2.378,0,0,1,2.378-2.378",
    transform: "translate(-7.026 -4.085)",
    fill: "#2e77ea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M78.876,57.555a5.991,5.991,0,0,0-4.234,10.221,1.779,1.779,0,0,1,0,2.515l-3.825,3.825a1.78,1.78,0,0,1-2.515,0A5.991,5.991,0,0,0,58.081,78.35,1.774,1.774,0,0,1,56.3,80.126h-5.41a1.775,1.775,0,0,1-1.776-1.776A5.988,5.988,0,0,0,38.9,74.116a1.776,1.776,0,0,1-2.511,0l-3.828-3.825a1.78,1.78,0,0,1,0-2.515,5.99,5.99,0,0,0-4.234-10.221,1.777,1.777,0,0,1-1.776-1.776V50.369a1.777,1.777,0,0,1,1.776-1.777A5.99,5.99,0,0,0,32.556,38.37a1.776,1.776,0,0,1,0-2.511l3.828-3.828a1.776,1.776,0,0,1,2.511,0A5.99,5.99,0,0,0,49.118,27.8a1.777,1.777,0,0,1,1.776-1.777H56.3A1.777,1.777,0,0,1,58.081,27.8,5.99,5.99,0,0,0,68.3,32.03a1.78,1.78,0,0,1,2.515,0l3.825,3.828a1.774,1.774,0,0,1,0,2.511,5.991,5.991,0,0,0,4.234,10.221,1.775,1.775,0,0,1,1.776,1.777v5.409a1.774,1.774,0,0,1-1.776,1.776",
    transform: "translate(-2.075 -2.033)",
    fill: "#6e75fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M54.666,68.63A14.49,14.49,0,1,0,40.175,54.14,14.521,14.521,0,0,0,54.666,68.63Z",
    transform: "translate(-3.14 -3.099)",
    fill: "#f8f6f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M19.511,38.009a3.84,3.84,0,1,1,0-2.922h5a1.462,1.462,0,0,1,1.461,1.461v2.731H30.6a4.519,4.519,0,0,0-1.151-1.91,3.236,3.236,0,0,1,0-4.577l3.828-3.828a3.238,3.238,0,0,1,4.578,0,4.529,4.529,0,0,0,7.728-3.2,3.238,3.238,0,0,1,3.237-3.238h5.41a3.238,3.238,0,0,1,3.238,3.238,4.529,4.529,0,0,0,7.728,3.2,3.243,3.243,0,0,1,4.581,0L73.6,32.792a3.236,3.236,0,0,1,0,4.577,4.5,4.5,0,0,0-1.151,1.91h4.624V36.548a1.461,1.461,0,0,1,1.46-1.461h5.555a3.839,3.839,0,1,1,0,2.922H79.995V40.74A1.462,1.462,0,0,1,78.533,42.2H72.583A4.464,4.464,0,0,0,76.8,45.1a3.234,3.234,0,0,1,3.238,3.238v.843H81.9a3.838,3.838,0,1,1-.333,2.922H80.039v1.644A3.234,3.234,0,0,1,76.8,56.981a4.463,4.463,0,0,0-4.218,2.9h5.951a1.461,1.461,0,0,1,1.461,1.461V64.07h4.094a3.839,3.839,0,1,1,0,2.921H78.533a1.46,1.46,0,0,1-1.46-1.46V62.8H72.449a4.489,4.489,0,0,0,1.151,1.91,3.244,3.244,0,0,1,0,4.582l-3.825,3.824a3.241,3.241,0,0,1-4.581,0,4.529,4.529,0,0,0-7.728,3.2,3.235,3.235,0,0,1-3.238,3.238h-5.41a3.235,3.235,0,0,1-3.237-3.238,4.528,4.528,0,0,0-7.728-3.2,3.238,3.238,0,0,1-4.578,0l-3.828-3.825a3.244,3.244,0,0,1,0-4.582A4.508,4.508,0,0,0,30.6,62.8H25.977v2.732a1.461,1.461,0,0,1-1.461,1.46h-5a3.839,3.839,0,1,1,0-2.921h3.545V61.339a1.46,1.46,0,0,1,1.46-1.461h5.952a4.465,4.465,0,0,0-4.22-2.9,3.237,3.237,0,0,1-3.237-3.238V52.5H21.889a3.839,3.839,0,1,1,0-2.921h1.122V48.334A3.237,3.237,0,0,1,26.248,45.1a4.466,4.466,0,0,0,4.22-2.9H24.516a1.461,1.461,0,0,1-1.46-1.461V38.009Zm-2.634-1.461a.917.917,0,1,0-.917.917.918.918,0,0,0,.917-.917m60.24,17.2V48.334a.315.315,0,0,0-.316-.315A7.453,7.453,0,0,1,71.535,35.3a.315.315,0,0,0,0-.445L67.71,31.029a.318.318,0,0,0-.449,0,7.452,7.452,0,0,1-12.716-5.267.316.316,0,0,0-.315-.316h-5.41a.316.316,0,0,0-.315.316,7.451,7.451,0,0,1-12.715,5.267.317.317,0,0,0-.446,0l-3.828,3.828a.314.314,0,0,0,0,.445,7.452,7.452,0,0,1-5.267,12.716.315.315,0,0,0-.315.315v5.409a.315.315,0,0,0,.315.316,7.452,7.452,0,0,1,5.267,12.715.317.317,0,0,0,0,.449l3.828,3.825a.315.315,0,0,0,.446,0A7.45,7.45,0,0,1,48.5,76.316a.315.315,0,0,0,.315.315h5.41a.315.315,0,0,0,.315-.315,7.453,7.453,0,0,1,12.716-5.267.317.317,0,0,0,.449,0l3.825-3.825a.318.318,0,0,0,0-.449A7.452,7.452,0,0,1,76.8,54.06a.316.316,0,0,0,.316-.316m-57.862-2.7a.917.917,0,1,0-.917.917.918.918,0,0,0,.917-.917M87.639,35.63a.917.917,0,1,0,.918.917.918.918,0,0,0-.918-.917M85.261,50.122a.917.917,0,1,0,.918.917.918.918,0,0,0-.918-.917m2.378,14.492a.917.917,0,1,0,.918.917.918.918,0,0,0-.918-.917m-71.679,0a.917.917,0,1,0,.917.917.918.918,0,0,0-.917-.917m35.566,2.377A15.951,15.951,0,1,1,67.478,51.041,15.982,15.982,0,0,1,51.526,66.992Zm0-2.921A13.029,13.029,0,1,0,38.5,51.041,13.057,13.057,0,0,0,51.526,64.07ZM44.942,51.536a1.461,1.461,0,0,1,2.066-2.067l2.906,2.9,6.166-5.765a1.461,1.461,0,1,1,1.995,2.134l-7.2,6.73a1.462,1.462,0,0,1-2.031-.034ZM99.3,33.076l.9-4.4a1.461,1.461,0,0,1,2.863.584l-2.03,9.952a1.46,1.46,0,0,1-2.4.8l-7.6-6.733a1.461,1.461,0,1,1,1.937-2.188l3.7,3.274a48.131,48.131,0,0,0-91.813,4.91,1.461,1.461,0,0,1-2.834-.714A51.053,51.053,0,0,1,99.3,33.076ZM6.352,67.658a48.131,48.131,0,0,0,91.834-4.852,1.461,1.461,0,0,1,2.833.713,51.052,51.052,0,0,1-97.262,5.54l-.862,4.35a1.461,1.461,0,1,1-2.866-.567L2,62.879A1.46,1.46,0,0,1,4.4,62.064l7.641,6.691a1.461,1.461,0,1,1-1.924,2.2Z",
    transform: "translate(0)",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 114,
    height: 114,
    transform: "translate(506 1964)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamlessInte);
export default __webpack_public_path__ + "static/media/seamlessInte.29ec9d5fbd5ca11464200ba1f5b13718.svg";
export { ForwardRef as ReactComponent };